
import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const zatcaInvoicesByDeletedCustom = /* GraphQL */ `query ZatcaInvoicesByDeleted(
  $deleted: String!
  $invoiceCounterNumber: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelZatcaInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  zatcaInvoicesByDeleted(
    deleted: $deleted
    invoiceCounterNumber: $invoiceCounterNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      taxInclusiveAmount
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ZatcaInvoicesByDeletedQueryVariables,
  APITypes.ZatcaInvoicesByDeletedQuery
>;